import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Card1Component } from './components/card1/card1.component';
import { Card2Component } from './components/card2/card2.component';
import { Card3Component } from './components/card3/card3.component';
import { Card4Component } from './components/card4/card4.component';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pixl-home',
  imports: [
    MatCardModule,
    CommonModule,
    TranslocoModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent {
  public dashboardItems = [
    { component: Card1Component },
    { component: Card2Component },
    { component: Card3Component },
    { component: Card4Component },
  ];

  public drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.dashboardItems, event.previousIndex, event.currentIndex);
  }
}
